<p class="header">{{ header }}</p>
<p class="bold">{{ bold }}</p>
<p class="text">{{ text }}</p>
<p class="text">{{ secondText }}</p>
